import { NotificationContext } from 'providers'
import { useContext, useMemo } from 'react'

export const useNotification = () => {
    const notifications = useContext(NotificationContext)

    return useMemo(() => notifications, [notifications])
}
